
<div mat-dialog-title>
  <fa-icon icon="times" (click)="onClick(false)" id="fdm-dialog-close" class="fdm-icon float-right"></fa-icon>
  {{data.title | translate }}
  <ng-container *ngIf="data?.input?.permissions">
    <input matInput type="text" required [formControl]="nameControl" [placeholder]="'SHARES.PUBLIC_SHARE' | translate" class="w-100 form-control" style="max-width: 300px !important;" (keyup.enter)="onClick(nameControl.value)">
    <mat-error *ngIf="nameControl.touched && nameControl.errors?.required">{{ 'GENERIC.FIELD_REQUIRED' | translate }}</mat-error>
  </ng-container>
</div>

<div mat-dialog-content id="AppDialogMainDIV">

  <!-- <textarea style="width:100%;font-size:9px;border:solid 2px green!important;height:100px;">{{ data | json }}</textarea> -->

  <div *ngIf="data.error && data.error.message && data.error.message.length > 0" class="alert alert-danger">
      {{ data.error.message | translate }}
  </div>

	<ng-container *ngIf="!data.error">

		<mat-divider *ngIf="data.title == 'FILE_LIST.NAV.SUPPORTED_FORMAT'"></mat-divider>
		<p style="white-space: pre-line;" *ngIf="!(data.meta?.file) && !(data.meta?.count)  && !data.meta?.deletename">{{data.text  | translate }}</p>
		<ng-container *ngIf="data.title == 'FILE_LIST.NAV.SUPPORTED_FORMAT'">
			<mat-divider></mat-divider><br>
			<small>{{'FILE_LIST.NAV.SUPPORTED_FORMAT_TEXT' | translate }}</small>
		</ng-container>
		<p *ngIf="data.meta?.deletename">{{data.text   | translate : { deletename: data.meta.deletename} }}</p>
		<p *ngIf="data.meta?.file">{{data.text  | translate : {file : data.meta.file} }}</p>
    <p *ngIf="data.meta?.count">{{data.text  | translate : { count: data.meta.count} }}</p>
  </ng-container>

    <ng-container *ngIf="data?.input && !folder_properties && !data?.input?.permissions">
        <mat-form-field class="w-100">
            <input matInput type="text" [placeholder]="data.input.placeholder | translate" [formControl]="inputControl" class="w-100 form-control" style="max-width: 300px !important;" (keyup.enter)="onClick(inputControl.value)">
            <mat-error *ngIf="inputControl.invalid">{{data.input.error}}</mat-error>
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="data?.input?.message">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{data?.input?.message | translate}}</mat-label>
        <textarea matInput [formControl]="inputControlMsg" style="max-width: 300px !important;"></textarea>
      </mat-form-field>
    </ng-container>

    <!-- External share link permissions -->

    <ng-container *ngIf="data?.input?.permissions">
      <div translate class="fdm-icon-projects">SHARES.ALLOW_USERS</div>
      <div style="border:solid 1px #eee;margin-bottom:10px;font-size:11px;padding: 5px;">
          <ng-container *ngFor="let p of roles">
              <mat-checkbox [(ngModel)]="p.use" style="margin-right:15px;"> {{ p.name}} </mat-checkbox>
          </ng-container> 
      </div>

        <!-- External share link expiry options -->

      <div translate class="fdm-icon-projects">GENERIC.OPTIONS</div>
      <div style="border:solid 1px #eee;margin-bottom:20px;font-size:11px; padding: 5px;">
        <div>
          <mat-checkbox [(ngModel)]="haveOptions"> {{ 'SHARES.EXPIRY' | translate }}
            <select id="optionExpireDays" ng-model="optionExpireDays">
              <option value="1">{{ 'SHARES.EXPIRY.1DAY' | translate }}</option>
              <option value="3">{{ 'SHARES.EXPIRY.3DAYS' | translate }}</option>
              <option value="7" selected>{{ 'SHARES.EXPIRY.7DAYS' | translate }}</option>
              <option value="14">{{ 'SHARES.EXPIRY.14DAYS' | translate }}</option>
              <option value="30">{{ 'SHARES.EXPIRY.1MONTH' | translate }}</option>
              <option value="60">{{ 'SHARES.EXPIRY.2MONTHS' | translate }}</option>
            </select>
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox [(ngModel)]="optionEmailShareLink">{{ 'SHARES.EMAIL' | translate }}</mat-checkbox>
          <ng-container *ngIf="optionEmailShareLink">
            <div class="mb-1">
              {{ 'SHARES.ADD_INST' | translate }}
            </div>
            <div>
              <mat-form-field class="w-100">
                <input matInput type="text" email [placeholder]="'SHARES.EMAIL' | translate" [formControl]="emailControl" class="w-100 form-control" style="max-width: 300px !important;" (keyup.enter)="onClick(emailControl.value)">
                <mat-error *ngIf="emailControl.invalid">{{data.input.error}}</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'GENERIC.MESSAGE' | translate}}</mat-label>
                <textarea matInput [formControl]="emailControlMsg" style="max-width: 300px !important;"></textarea>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
      </div>
  </ng-container>

  <ng-container *ngIf="folder_properties">
    <table style="border:solid 1px #fff;margin-bottom:10px;font-size:13px;width:100%;">
        <tr *ngFor="let p of folder_properties">
          <ng-container *ngIf="!p.type">
            <td>{{ p.key | normaliseAcl | async}}</td> <td>{{ p.value }}</td>
          </ng-container>
          <ng-container *ngIf="p.type && p.type == 'text'">
            <td>{{ p.key | normaliseAcl | async}}</td>
            <td><input matInput type="text" [value]="p.value" class="w-100" style="max-width: 300px !important;"></td>
          </ng-container>
          <ng-container *ngIf="p.type && p.type == 'check'">
            <td colspan="2">
              <mat-checkbox [(ngModel)]="p.value" style="margin-right:15px;"> {{ p.key | normaliseAcl | async}} </mat-checkbox>
            </td>
          </ng-container>
          
          
        </tr> 
    </table>
</ng-container>

    <div *ngIf="data.mode == 'folder' || data.mode == 'file' || data.mode == 'file_all'" style="position:relative;min-height: 400px; margin-left:-24px;margin-right:-24px;border:1px solid #CCC">
      <explorer-comp [project]="data.meta?.project" [transform_group]="data.meta?.transform_group" [dialog]="true" (filesSelected)="selectedFiles = $event" [selectFiles]="data.mode != 'folder'" (folderSelected)="setVal($event)"></explorer-comp>
    </div>
    <div *ngIf="data.mode == 'user' && users" style="position:relative;min-height: 400px;">

        <mat-list class="mr-1">
          <a mat-list-item (click)="currentProject = proj" *ngFor="let user of results?.items" [ngClass]="{'primary-bg':selectedUser == user}" (click)="selectedUser = user">
            <img matListIcon vlink="image.png" [model]="user" />
            <h3 matLine routerLinkActive="primary"> {{user.name}} </h3>
          </a>
        </mat-list>

    </div>

	<!-- <textarea class="bug">{{ data | json }}</textarea> -->

</div>
<div mat-dialog-actions class="align-content-right" style="margin-bottom:inherit!important">

    <!-- button for cancel / no / false  (first, so it left-aligns -->
    <button mat-stroked-button  *ngIf="data.negBtn" (click)="onClick(false)" translate>{{data.negBtn | translate }}</button>


    <!-- button for selected folder? -->
    <button mat-flat-button color="primary" *ngIf="data.mode == 'folder' || data.mode == 'file_all' && !selectedFiles?.length" (click)="dialogRef.close(selectedFolder)"
    [disabled]="!selectedFolder">
      <label *ngIf="data.title !== 'FILE_LIST.MOVE.FILE_TITLE'; else moveHere" >
        {{ 'FILE_LIST.DIALOG.FOLDER' | translate: { name : selectedFolder && selectedFolder.name ? selectedFolder.name : ' Root' } }}
      </label>
      <ng-template #moveHere>
        {{ 'FILE_LIST.MOVE.HERE' | translate }}
      </ng-template>
    </button>

    <!-- button for choosing file(s) -->
    <button mat-flat-button color="primary" *ngIf="data.mode == 'file' || data.mode == 'file_all'"  (click)="dialogRef.close(selectedFiles)"
    [disabled]="!selectedFiles?.length">
      {{ 'FILE_LIST.DIALOG.FILES' | translate:{count:selectedFiles?.length || ''} }}
    </button>

    <!-- button for external link -->
    <button mat-stroked-button color="primary" *ngIf="data.input && data.isExternalURL && inputControl.valid" [matTooltip]="'MAP.OPEN_EXTERNAL_LINK' | translate" (click)="openURL()">
      <fa-icon icon="link"></fa-icon>
    </button>

    <!-- button OK / select / choose / Yes / OK -->
    <button mat-flat-button color="primary" *ngIf="inputControl?.value && data.mode != 'folder' && data.mode != 'file' && data.mode != 'file_all'"  (click)="onClick(inputControl.value)"
    [disabled]="
    (data.input && (inputControl?.invalid || inputControl?.value?.trim().length < 2 ) )
      ||

      ((data.mode == 'file' || data.mode == 'file_all')  && (!selectedFolder) && !data.input)
      ||
      (data.mode == 'user' && !selectedUser)
      ||
      ((data.mode == 'file' || data.mode == 'file_all')  && (  !selectedFolder) && ((data.input && inputControl?.value?.trim() === passedValue && !inputControl?.dirty)))">
      {{(data.posBtn ? data.posBtn : "GENERIC.OK") | translate }}
    </button>

    <button mat-flat-button color="primary" *ngIf="!inputControl?.value && data.mode != 'folder' && data.mode != 'file' && data.mode != 'file_all'"  (click)="onClick(true)">
      {{(data.posBtn ? data.posBtn : "GENERIC.OK") | translate }}
    </button>

    <!-- <textarea style="height:100px;font-size:8px;width:100%;">{{ data | json }}</textarea>
    <textarea style="height:100px;font-size:8px;width:100%;">{{ inputControl | json }}</textarea> -->

  <!-- <div>

    <button mat-button color="default">normal, default</button>
    <button mat-button color="primary">normal, primary</button>
    <button mat-button color="accent">normal, accent</button>

    <button mat-raised-button color="default">raised, default</button>
    <button mat-raised-button color="primary">raised, primary</button>
    <button mat-raised-button color="accent">raised, accent</button>

    <button mat-stroked-button color="default">stroked, default</button>
    <button mat-stroked-button color="primary">stroked, primary</button>
    <button mat-stroked-button color="accent">stroked, accent</button>

    <button mat-flat-button color="default">flat, default</button>
    <button mat-flat-button color="primary">flat, primary</button>
    <button mat-flat-button color="accent">flat, accent</button>

  </div> -->
</div>
